export default "__VITE_ASSET__C6yMxNj0__"